import aa from "search-insights";
import { ALGOLIA_APP_ID, SEARCH_API_KEY, ALGOLIA_PRODUCTS_INDEX, ALGOLIA_BLOGS_INDEX, ALGOLIA_COLLECTIONS_INDEX } from "utils/constants";

let isInitialized = false;

export const initAlgoliaAnalytics = () => {
	if (isInitialized) return false;
	aa("init", {
		appId: ALGOLIA_APP_ID,
		apiKey: SEARCH_API_KEY,
		useCookie: true,
	});
	isInitialized = true;
	return true;
};

// HELPER FUNCTION
export const trackClickedObjectIDsAfterSearch = (
	eventName,
	index,
	objectIDs,
	positions,
	queryID,
) => {
	const payload = {
		eventName,
		index,
		objectIDs,
		positions,
		queryID,
	};
	aa("clickedObjectIDsAfterSearch", payload);
};

export const trackProductClicked = (objectIDs, positions, queryID) =>
	trackClickedObjectIDsAfterSearch("Product Clicked", ALGOLIA_PRODUCTS_INDEX, objectIDs, positions, queryID);

export const trackBlogClicked = (objectIDs, positions, queryID) =>
	trackClickedObjectIDsAfterSearch("Blog Clicked", ALGOLIA_BLOGS_INDEX, objectIDs, positions, queryID);

export const trackCollectionClicked = (objectIDs, positions, queryID) =>
	trackClickedObjectIDsAfterSearch("Collection Clicked", ALGOLIA_COLLECTIONS_INDEX, objectIDs, positions, queryID);

// UPDATE USE CASE 
export const trackConvertedObjectIDsAfterSearch = (eventName, objectIDs, queryID) => {
	const payload = {
		eventName,
		index: ALGOLIA_PRODUCTS_INDEX,
		objectIDs,
		queryID,
	};

	aa("convertedObjectIDsAfterSearch", payload);
};

export const trackWishlistAdded = (objectIDs, queryID) =>
	trackConvertedObjectIDsAfterSearch("Added to Wishlist", objectIDs, queryID);


export const trackAddedToCartObjectIDs = (queryID, objectIDs, objectData, value, currency = "USD") => {
	const payload = {
		eventName: "Product Added to Cart",
		index: ALGOLIA_PRODUCTS_INDEX,
		queryID,
		objectIDs,
		objectData,
		value,
		currency,
	};

	aa("addedToCartObjectIDsAfterSearch", payload);
};
